import { USE_MOCK } from '@/lib/api/env';
import type { NotificationApi } from './notificationsAdapter';
import { notificationsHttp } from './notificationsHttp';
import { notificationsMock } from './notificationsMock';

/**
 * LIVE by default — `/api/v1/notifications` plus `user:<self>` on the gateway.
 * `VITE_USE_MOCK=true` restores the seeded feed. Every consumer is typed
 * against `NotificationApi` only.
 */
export const notificationApi: NotificationApi = USE_MOCK ? notificationsMock : notificationsHttp;
